import { AssignedRoleDto } from './assigned-role-model';
export class UserInfoData {
    userList: Array<AssignedRoleDto>;
    totalCount: number;

    constructor() {
        this.userList = [];
        this.totalCount = 0;
    }
}